import type { ApiKeyDto, CreatedApiKeyDto } from '@today/types'
import { apiClient } from './api.client'

const BASE = '/users/me/api-keys'

/** The signed-in user's personal API keys (TO-516). */
export const apiKeysService = {
	/** `GET /users/me/api-keys` — newest first. */
	async list(): Promise<ApiKeyDto[]> {
		const { data } = await apiClient.get<{ data: ApiKeyDto[] }>(BASE)
		return data.data
	},

	/** `POST /users/me/api-keys` — the only response that carries the plaintext key. */
	async create(body: { name: string; expiresInDays?: number }): Promise<CreatedApiKeyDto> {
		const { data } = await apiClient.post<CreatedApiKeyDto>(BASE, body)
		return data
	},

	/** `PATCH /users/me/api-keys/{id}` — relabels the key. */
	async rename(apiKeyId: string, name: string): Promise<ApiKeyDto> {
		const { data } = await apiClient.patch<ApiKeyDto>(`${BASE}/${encodeURIComponent(apiKeyId)}`, { name })
		return data
	},

	/** `DELETE /users/me/api-keys/{id}` — 204, idempotent. */
	async revoke(apiKeyId: string): Promise<void> {
		await apiClient.delete(`${BASE}/${encodeURIComponent(apiKeyId)}`)
	},
}
